import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import de from 'vuetify/es5/locale/de';
import en from 'vuetify/es5/locale/en';
import it from 'vuetify/es5/locale/it';

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#0d5890',
        secondary: '#424242',
        accent: '#fbc112',
        error: '#FF5252',
        info: '#2196F3',
        success: '#54b05b',
        warning: '#FFC107',
      },
    },
  },
  lang: {
    locales: {
      de,
      en,
      it,
    },
    current: 'de',
  },
  icons: {
    iconfont: 'mdi',
  },
};

export default new Vuetify(opts);
